module.exports = __webpack_public_path__ + "img/p8.bfd38434.png";